import React, { useMemo } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { copyText } from "../../../helpers/functions";
import CustomTable from "../../../components/ui/tables/CustomTable";
import { FaCopy } from "react-icons/fa";
import { useAuth } from "../../../providers/AuthContext";

const SportBetBookDetailModal = ({ data }) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const tableData = data.odds?.map((item, index) => {
    return {
      ...item,
    };
  });

  const tableColumns = useMemo(
    () => [
      // {
      //   accessorKey: "transaction_id",
      //   header: "Bet Id",
      //   size: 200,
      //   Cell: ({ cell }) => <strong>{cell.row.original?.transaction_id}</strong>,
      // },

      {
        accessorKey: "category.name",
        header: "Category",
        size: 100,
      },
      {
        accessorKey: "tournament.name",
        header: "Tournament",
        size: 100,
      },
      {
        accessorKey: "odd.oddValue",
        header: "Odd",
        size: 50,
        Cell: ({ cell }) => (cell.row.original?.odd ? cell.row.original?.odd?.oddValue : <strong class="font-bold">-</strong>),
      },
      {
        accessorKey: "odd.name",
        header: "Selection",
        size: 50,
        Cell: ({ cell }) => (cell.row.original?.odd ? cell.row.original?.odd?.name : <strong class="font-bold">-</strong>),
      },
      {
        accessorKey: "market.name",
        header: "Market",
        size: 100,
        Cell: ({ cell }) => (cell.row.original?.market ? cell.row.original?.market.name : <strong class="font-bold">-</strong>),
      },
      {
        accessorKey: "match",
        header: "Match (Home ---- Away)",
        size: 200,
        Cell: ({ cell }) => cell.row.original?.match?.home + " ---- " + cell.row.original?.match?.away,
      },

      {
        accessorKey: "sport.name",
        header: "Sport",
        size: 100,
      },

      {
        accessorKey: "state",
        header: "Bet Status",
        size: 50,
        Cell: ({ cell }) => {
          const statusColors = {
            running: "bg-blue-200 text-blue-700",
            lost: "bg-slate-200 text-slate-700",
            won: "bg-green-200 text-green-700",
            void: "bg-yellow-200 text-yellow-700",
            cancelled: "bg-orange-200 text-orange-700",
            rejected: "bg-red-200 text-red-700",
            "cash-out": "bg-purple-200 text-purple-700",
            reserved: "bg-red-200 text-red-700",
            concluded: "bg-slate-200 text-slate-700",
            confirmed: "bg-green-200 text-green-700",
          };

          const status = cell.row.original?.state?.toLowerCase();
          return (
            <div className="flex">
              {statusColors[status] ? (
                <div className={`${statusColors[status]} font-bold text-center rounded px-2 capitalize`}>{status}</div>
              ) : (
                status
              )}
            </div>
          );
        },
      },
    ],
    []
  );

  return (
    <>
      <div className="md:flex md:space-x-10 md:space-y-0 space-y-4" style={{ padding: "0 35px 40px" }}>
        <div className="block">
          <label className="block text-[#ababab] text-md font-medium">{t("Ticket Code")}</label>
          <span className="flex items-center text-white" required autoComplete="off">
            {data?.ticketCode}{" "}
            <span className="ml-5 text-slate-400 " onClick={() => copyText(data?.userId)}>
              <FaCopy />
            </span>
          </span>
        </div>{" "}
        <div className="block">
          <label className="block text-[#ababab] text-md font-medium">{t("User Id")}</label>
          <span className="flex items-center text-white" required autoComplete="off">
            {data?.userId}{" "}
            <span className="ml-5 text-slate-400 " onClick={() => copyText(data?.userId)}>
              <FaCopy />
            </span>
          </span>
        </div>{" "}
        <div className="block">
          <label className="block text-[#ababab] text-md font-medium">{t("Date")}</label>

          <span className="text-white" required autoComplete="off">
            {moment?.tz(data?.createdAt, "UTC")?.format("YYYY-MM-DD HH:mm:ss")}
          </span>
        </div>{" "}
        {/* <div className="block"></div> */}
        <div className="block">
          <label className="block text-[#ababab] text-md font-medium">{t("Amount")}</label>

          <span className="text-white" required autoComplete="off">
            {data?.amount} <span className="text-slate-400">{user?.currency}</span>
          </span>
        </div>
        <div className="block">
          <label className="block text-[#ababab] text-md font-medium">{t("Status")}</label>
          <span className="text-white capitalize" required autoComplete="off">
            {data?.status}
          </span>
        </div>
      </div>
      <CustomTable noWrap columns={tableColumns} data={tableData ? tableData : []} enableGlobalFilter={true} enableTopToolbar={true} />
    </>
  );
};

export default SportBetBookDetailModal;
